<h1>Mail-Entwurfs-Generator</h1>

<style>
    h1 {
        text-align: center;
    }
</style>